<template>
  <WsRead
    :modelName="modelName"
    :id="$route.params.id"
    :localeMode="localeMode"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    titleKey="last_version.name"
  >
  </WsRead>
</template>

<script>
import model from "@/models/exit_check_item_template";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    localeMode: true,
    fields: model.fields,
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "收工檢查項目資訊",
              fields: ["locales", "remark"],
            },
          ],
        },
      ],
      secondary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "設定",
              fields: [
                "sequence",
                "area",
                "area_section",
                // "system_class",
                // "system_subclasses",
                "industry_categories",
              ],
            },
          ],
        },
        {
          type: "infoCard",
          floors: [
            {
              title: "建立資訊",
              fields: ["updated_at", "updated_admin"],
            },
          ],
        },
        {
          type: "infoCard",
          floors: [
            {
              title: "編輯資訊",
              fields: ["updated_at", "updated_admin"],
            },
          ],
        },
        {
          type: "activeSwitch",
          title: "顯示設定",
          remark: "隱藏的內容將不會顯示於前端",
          field: "is_active",
        },
      ],
    },
  }),
};
</script>